import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ManageFilterComponent } from '@app/shared/components/manage-filter/manage-filter.component';
import { PageNavigationComponent } from '@app/shared/components/page-navigation/page-navigation.component';
import { ImageUrls } from '@app/shared/constants/image-urls-const';
import { SharedModule } from '@app/shared/shared.module';
import { CommonFunctions } from '@app/shared/util/common-functions';
import { Sort } from '@angular/material/sort';
import { LoaderService } from '@app/core/services/loader.service';
import { InstitutionService } from '@app/pages/institution/service/institution.service';
import { NoFilterDataFoundComponent } from '../no-filter-data-found/no-filter-data-found.component';
import { EasyLoadService } from '@app/shared/services/easy-load.service';
import { Utilities } from '@app/core/utils/utilities';
import { ReportConstants } from '@app/pages/subject-report/util/report-constants';

@Component({
  selector: 'app-report-listing-popup',
  templateUrl: './report-listing-popup.component.html',
  styleUrl: './report-listing-popup.component.css',
  imports: [CommonModule, SharedModule, PageNavigationComponent, ManageFilterComponent, NoFilterDataFoundComponent]
})
export class ReportListingPopupComponent implements OnInit, OnDestroy {
  reportData = inject(MAT_DIALOG_DATA);
  commonFunction = inject(CommonFunctions);
  imageConst = inject(ImageUrls);
  institutionService = inject(InstitutionService);
  easyLoadService = inject(EasyLoadService);
  loaderService = inject(LoaderService);
  reportConstants: any = inject(ReportConstants);
  util = inject(Utilities);
  reportSortDetails: any = {};
  reportRefDetails: any = {};
  appliedReportFilterDetails: any = {};
  filterDetails = signal<any>({});
  dataSource = signal<any>(null);

  totalRecordCount = signal<number>(0);
  currentPageNumber: number = 1;
  hideShowFilterOption = signal<boolean>(false);
  showTableContent = signal<boolean>(false);
  displayedColumns: string[] = ['reportTitle', 'errorManual', 'uploadedBy', 'uploadedAt', 'download'];
  entityType: string = '';
  listPageSize: number = this.util.recordsPerPage();

  ngOnInit(): void {
    this.getEntityType();
  }

  getEntityType() {
    this.util.recordsPerPage.set(10);
    const reportPageData: any = this.reportConstants?.[this.reportData?.fromPage?.toLowerCase()];
    this.entityType = reportPageData?.entityType || '';
    this.getReportDetails();
  }

  getReportDetails(sortBy?: any, sortOrder?: any, appliedFilter?: any, from?: string) {
    this.totalRecordCount.set(0);
    if (from) this.showTableContent.set(false);
    this.easyLoadService.getReportDetails(this.reportData?.institutionId, this.currentPageNumber, this.entityType, sortBy, sortOrder, appliedFilter).subscribe({
      next: ((data: any) => {
        this.dataSource.set(new MatTableDataSource(data.reports));
        this.totalRecordCount.set(data.totalRecordCount);
        this.showTableContent.set(true);
      }),
      error: ((err: any) => {
        console.log('error in report list', err);
      })
    })
  }

  clearReportFilterOption(columnDetails?: any) {
    if (columnDetails)
      delete this.appliedReportFilterDetails[columnDetails];
    else
      this.appliedReportFilterDetails = {};
    this.currentPageNumber = 1;
    this.getReportDetails(this.reportSortDetails?.active, this.reportSortDetails?.direction, this.appliedReportFilterDetails, this.retaingReportSortingDetails())
  }

  fetchAjaxRefData(id: any, name: any, type: any) {
    if (!this.reportRefDetails[id?.toLowerCase()])
      this.institutionService.getInstitutionAjaxDetails(id, this.reportData?.institutionId).subscribe({
        next: ((ajaxRefData: any) => {
          const reportAjaxDetails = ajaxRefData.referenceTypes;
          reportAjaxDetails.forEach((refData: any) => {
            this.reportRefDetails[refData.name.toLowerCase()] = refData.values;
            this.showFetchedReportFilterDetails(id, name, type);
          })
        }),
        error: ((err: any) => {
          console.log('error in ajax ref data', err)
        })
      })
    else
      this.showFetchedReportFilterDetails(id, name, type);
  }

  showFetchedReportFilterDetails(id: any, name: any, type: any) {
    this.hideShowFilterOption.set(true);
    const filterData = {
      filterId: id,
      filterType: type,
      filterName: name,
      referenceDetails: this.reportRefDetails[id.toLowerCase()]
    }
    this.filterDetails.set(filterData);
  }

  sortReportTableChanges(event: Sort) {
    this.reportSortDetails = this.commonFunction.updateSortingdetails(event);
    this.currentPageNumber = 1;
    this.getReportDetails(this.reportSortDetails?.active, this.reportSortDetails?.direction, this.appliedReportFilterDetails, this.retaingReportSortingDetails());
  }

  closeFilterPopup() {
    this.hideShowFilterOption.set(false);
  }

  searchReportFilterDetails(filterDetails: any) {
    this.closeFilterPopup();
    this.currentPageNumber = 1;
    this.appliedReportFilterDetails[filterDetails.filterBy] = filterDetails.filterValue
    this.getReportDetails(this.reportSortDetails?.active, this.reportSortDetails?.direction, this.appliedReportFilterDetails, this.retaingReportSortingDetails());
  }

  getPaginationDetails(pageNumber: any) {
    this.currentPageNumber = pageNumber;
    this.getReportDetails(this.reportSortDetails?.active, this.reportSortDetails?.direction, this.appliedReportFilterDetails, this.retaingReportSortingDetails());
  }

  retaingReportSortingDetails() {
    return this.reportSortDetails?.active ? 'matSortApplied' : '';
  }

  downloadReport(reportDetails: any) {
    this.easyLoadService.getDownloadReportPreSignedUrl(reportDetails.fileName, this.entityType, 'report_popup').subscribe({
      next: ((data: any) => {
        const url = data.download_url;
        this.loaderService.forceCloseOverlay();
        if (url)
          this.util.downloadFile(url, reportDetails.fileName);
      }),
      error: ((err: any) => console.error('Error getting download presigned url for reports', err))
    })
  }

  ngOnDestroy(): void {
    this.util.recordsPerPage.set(this.listPageSize);
  }
}
